<div class="dialog-container bg-dark font-white p-4">
  <div class="d-flex justify-content-between align-items-center mb-4 border-bottom border-secondary pb-3">
    <h2 class="m-0 fs-20 fw-bold">User Rights: {{ userName }}</h2>
    <div (click)="onClose()" class="close-icon cursor-pointer">
      <div [innerHTML]="SVG_ICONS.CLOSE_ICON() | sanitizer : 'html'"></div>
    </div>
  </div>

  @if (isLoading) {
  <div class="text-center py-5">
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-2 font-gray">Fetching permissions...</p>
  </div>
  } @else { @if (masterMenuList.length === 0) {
  <div class="text-center py-5 font-gray">No modules found with rights for this user.</div>
  } @else {
  <div class="permission-tree-container border-radius-5 overflow-auto" style="max-height: 60vh">
    <div class="menu-row header-row fw-bold fs-12 font-gray border-bottom px-3 py-2 sticky-top">
      <div class="menu-name">Module Name</div>
      <div class="menu-perms d-flex justify-content-between align-items-center gap-4">
        <span class="perms-label">CREATE</span>
        <span class="perms-label">UPDATE</span>
        <span class="perms-label">DELETE</span>
      </div>
    </div>

    <div class="menu-body">
      @for (item of masterMenuList; track item.MenuID) {
      <ng-container [ngTemplateOutlet]="MenuItemTemplate" [ngTemplateOutletContext]="{ item: item, parent: null }"></ng-container>
      }
    </div>
  </div>
  }

  <div class="d-flex justify-content-end gap-3 mt-4 border-top border-secondary pt-3">
    <button class="btn btn-outline-secondary px-4 py-1" (click)="onClose()">Close</button>
    <button class="btn btn-success px-4 py-1 d-flex align-items-center gap-2">
      <span class="fs-14">Update Permissions</span>
    </button>
  </div>
  }
</div>

<ng-template #MenuItemTemplate let-item="item" let-parent="parent">
  <div class="menu-item-container border-bottom border-secondary-subtle">
    <div class="menu-row px-3 py-2 d-flex align-items-center">
      <div class="menu-name d-flex align-items-center gap-2">
        <div class="expander d-flex align-items-center justify-content-center" (click)="toggleMenuItem(item)" [style.visibility]="item.ChildList?.length ? 'visible' : 'hidden'">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            [@indicatorRotate]="item.expanded ? 'expanded' : 'collapsed'">
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </div>
        <span class="menu-text fs-14">{{ item.MenuName }}</span>
      </div>
      <div class="menu-perms d-flex justify-content-around align-items-center">
        <div class="custom-checkbox cursor-pointer" [class.checked]="item.canAdd" (click)="togglePermission(item, 'add', parent)">
          <div [innerHTML]="SVG_ICONS.G_CHECK_ICON() | sanitizer : 'html'" class="checkmark"></div>
        </div>
        <div class="custom-checkbox cursor-pointer" [class.checked]="item.canEdit" (click)="togglePermission(item, 'edit', parent)">
          <div [innerHTML]="SVG_ICONS.G_CHECK_ICON() | sanitizer : 'html'" class="checkmark"></div>
        </div>
        <div class="custom-checkbox cursor-pointer" [class.checked]="item.canDelete" (click)="togglePermission(item, 'delete', parent)">
          <div [innerHTML]="SVG_ICONS.G_CHECK_ICON() | sanitizer : 'html'" class="checkmark"></div>
        </div>
      </div>
    </div>

    @if (item.expanded && item.ChildList?.length) {
    <div class="child-container ps-4">
      @for (child of item.ChildList; track child.MenuID) {
      <ng-container [ngTemplateOutlet]="MenuItemTemplate" [ngTemplateOutletContext]="{ item: child, parent: item }"></ng-container>
      }
    </div>
    }
  </div>
</ng-template>
